import * as yup from 'yup';

import { Model as AdminModel } from 'models/user/interface';

import { endpoint, EndpointError } from '../endpoint';
import { ValidationShape, ERROR as VALIDATION_ERROR } from '../validation';

export type CheckUserParams = {
  phone: string;
};

export type CheckUserResult = { isCheckPassed: boolean };
export type CheckUserError = EndpointError;

export type SignInParams =
  | {
      // not relevant
      provider: 'custom';
      user: string;
      password: string;
    }
  | {
      // not relevant
      provider: 'google';
      email: string;
      idToken?: string;
    }
  | {
      provider: 'phone';
      phone: string;
      uid: string;
      idToken?: string;
    };

export type SignInResult = AdminModel & { token: string };
export type SignInError = EndpointError;

// not relevant
export const customSignInParamsSchema = yup.object().shape({
  provider: yup.string().oneOf(['custom'], VALIDATION_ERROR.INVALID_VALUE).required(VALIDATION_ERROR.REQUIRED),
  user: yup.string().email(VALIDATION_ERROR.INVALID_VALUE).required(VALIDATION_ERROR.REQUIRED),
  password: yup.string().required(VALIDATION_ERROR.REQUIRED),
} as ValidationShape<SignInParams & { provider: 'custom' }>);

// not relevant
export const googleSignInParamsSchema = yup.object().shape({
  provider: yup.string().oneOf(['google'], VALIDATION_ERROR.INVALID_VALUE).required(VALIDATION_ERROR.REQUIRED),
  email: yup.string().email(VALIDATION_ERROR.INVALID_VALUE).required(VALIDATION_ERROR.REQUIRED),
} as ValidationShape<SignInParams & { provider: 'google' }>);

export const phoneSignInParamsSchema = yup.object().shape({
  provider: yup.string().oneOf(['phone'], VALIDATION_ERROR.INVALID_VALUE).required(VALIDATION_ERROR.REQUIRED),
  uid: yup.string().required(VALIDATION_ERROR.REQUIRED),
  phone: yup
    .string()
    .min(9, VALIDATION_ERROR.INVALID_VALUE)
    .max(13, VALIDATION_ERROR.INVALID_VALUE)
    .required(VALIDATION_ERROR.REQUIRED),
} as ValidationShape<SignInParams & { provider: 'phone' }>);

export const checkUserParamsSchema = yup.object().shape({
  phone: yup
    .string()
    .min(9, VALIDATION_ERROR.INVALID_VALUE)
    .max(13, VALIDATION_ERROR.INVALID_VALUE)
    .required(VALIDATION_ERROR.REQUIRED),
} as ValidationShape<CheckUserParams>);

export const signIn = endpoint<SignInParams, SignInResult, SignInError>({
  method: 'POST',
  url: () => `/auth/admin`,
});

export const checkUser = endpoint<CheckUserParams, CheckUserResult, CheckUserError>({
  method: 'POST',
  url: () => `/auth/admin/check-user`,
});
